import { FETCH_LOT_DETAILS_ERROR, NOT_ME_ERROR, FETCH_LOT_DETAILS_SUCCESS, FETCH_BASIC_LOT_DETAILS_SUCCESS, FETCH_BASIC_LOT_DETAILS_ERROR } from "../actions/lot";
import { CALL_ME_ERROR } from "../actions/infoHelp";
import { FETCH_GEOSUGGEST_ADDRESS_ERROR } from "../actions/address";
import { PICKUP_FROM_SUBMISSION_ERROR, PICKUP_FROM_SUBMISSION_SUCCESS } from "../actions/pickupForm";
import {
  GOTO_VIEW,
  UPDATE_API_RETRY_COUNT,
} from "../actions/ui";
import { showNotification } from "../actions/notification";
import { setInfoHelpPage } from "../actions/infoHelp";
import locale from "../../utils/locale";
const MAX_RETRIES = 3;

export const fetchLotDetailsError = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === FETCH_LOT_DETAILS_ERROR || action.type === FETCH_BASIC_LOT_DETAILS_ERROR) {
    warnAndShowErrorPage(dispatch, "failedToFetchLotDetails")
  }

  if ((action.type === FETCH_LOT_DETAILS_SUCCESS || action.type === FETCH_BASIC_LOT_DETAILS_SUCCESS) && action.payload.messageType==="error") {
    dispatch(setInfoHelpPage(action.payload.message));
    dispatch({ type: GOTO_VIEW, payload: "InfoHelpView" });  
  }
};

export const submitNotMeError = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === NOT_ME_ERROR) {
    dispatch(showNotification(locale("retry")));
  }
};

export const submitCallMeError = ({ dispatch }) => next => action => {
  next(action);
  if (action.type === CALL_ME_ERROR) {
    dispatch(showNotification(locale("retry")));
  }
};

export const submitPickupFormError = ({ dispatch, getState }) => next => action => {
  next(action);
  if (action.type === PICKUP_FROM_SUBMISSION_ERROR) {
    const retryCount = getState().ui.apiRetryCount;
    dispatch({ type: UPDATE_API_RETRY_COUNT });
    
    if (retryCount >= MAX_RETRIES) {
        dispatch(setInfoHelpPage(locale("couldntSubmitForm", getState().lot.yardPhoneNumber)));
        dispatch({ type: GOTO_VIEW, payload: "InfoHelpView" });
    } else {
        dispatch(showNotification(locale("retry")));
    }
  }

  if (action.type === PICKUP_FROM_SUBMISSION_SUCCESS) {
   if(action.payload.status === "error"){
    dispatch(showNotification(locale("resubmit_form")));
   }
  }
};

export const fetchGoogleSuggestAddressError = ({
  dispatch
}) => next => action => {
  next(action);
  if (action.type === FETCH_GEOSUGGEST_ADDRESS_ERROR) {
    dispatch(showNotification(locale("failedToValidateAddress")));
  }
};

const warnAndShowErrorPage = (dispatch, message) => {
    dispatch(showNotification(locale(message)));
    dispatch(setInfoHelpPage(locale("networkFailure")));
    dispatch({ type: GOTO_VIEW, payload: "InfoHelpView" });
}

export const errosMdl = [
  fetchLotDetailsError,
  submitNotMeError,
  submitCallMeError,
  submitPickupFormError,
  fetchGoogleSuggestAddressError
];



// WEBPACK FOOTER //
// ./src/redux/middleware/errors.js